export default __webpack_public_path__ + "static/media/refunded_icon.25ddde90.svg";